import { render, staticRenderFns } from "./OnboardingDomainVerificationModal.vue?vue&type=template&id=6344118d&scoped=true"
import script from "./OnboardingDomainVerificationModal.vue?vue&type=script&lang=js"
export * from "./OnboardingDomainVerificationModal.vue?vue&type=script&lang=js"
import style0 from "./OnboardingDomainVerificationModal.vue?vue&type=style&index=0&id=6344118d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6344118d",
  null
  
)

export default component.exports